export interface IText {
    alerts: string;
    errorsHaveOccurred: string;
    loading: string;
    minimize: string;
    new: string;
    noAlerts: string;
    noAlertsDescription: string;
}

export const isIText = (obj: object): obj is IText => {

    // Check all properties exist.
    if ((obj as IText).alerts === undefined) { return false; };
    if ((obj as IText).errorsHaveOccurred === undefined) { return false; };
    if ((obj as IText).loading === undefined) { return false; };
    if ((obj as IText).minimize === undefined) { return false; };
    if ((obj as IText).new === undefined) { return false; };
    if ((obj as IText).noAlerts === undefined) { return false; };
    if ((obj as IText).noAlertsDescription === undefined) { return false; };

    return true;
};
